import React from 'react';
const Footer = () => {
    
    return (
        <footer className='footer'>
            <div className='footer__bg'>
                <div className='footer__container container grid'>
                    <div>
                        <h2 className='footer__title'>Shafnas</h2>
                        <span className='footer__subtitle'>Senior Software Engineer</span>
                    </div>

                    <ul className='footer__links'>
                        <li>
                            <a href='#services' className='footer__link'>Services</a>
                        </li>
                        <li>
                            <a href='#portfolio' className='footer__link'>Portfolio</a>
                        </li>
                        <li>
                            <a href='#contact' className='footer__link'>Contact</a>
                        </li>
                    </ul>

                    <div className='footer__socials'>
                        <a href="https://github.com/mshafnas" target="_blank" rel='noopener noreferrer' className="footer__social">
                            <i className="uil uil-github-alt"></i>
                        </a>
                        <a href="https://www.linkedin.com/in/mohamed-shafnas-7002191ab/" target="_blank" rel='noopener noreferrer' className="footer__social">
                            <i className="uil uil-linkedin-alt"></i>
                        </a>
                        <a href="https://www.facebook.com/mshafnaz1" target="_blank" rel='noopener noreferrer' className="footer__social">
                            <i className="uil uil-facebook-f"></i>
                        </a>
                        <a href="tel::+94770048000" className="footer__social">
                            <i className="uil uil-whatsapp"></i>
                        </a>
                    </div>
                </div>

                <p className='footer__copy'>&#169; Shafnas. All rights reserved.</p>
            </div>
        </footer>
            
    )
}

export default Footer;